import Vue from "vue";

/**
 * Class Lead Service
 */
export default class LeadService extends Vue {
  private customActions = {
        attribute: { method: "GET", url: "lead/attribute/{platformId}" },
        report: { method: "GET", url: "lead/report/{platformName}{/firstDate}{/lastDate}" },
        chartFilters: { method: "GET", url: "lead/chartFilters{/firstDate}{/lastDate}" },
        reportGraphic: { method: "GET", url: "lead/report-graphic/{platformName}{/firstDate}{/lastDate}?groupBy=[{groupBy}]" },
        updateExport: { method: "POST", url: "lead/exportDate" },
        hotLeadParams: { method: "GET", url: "lead/hotleads/{platformId}/params" },
        hotLeads: { method: "GET", url: "lead/hotleads/{platformId}" },
        setHotLeads: { method: "POST", url: "lead/hotleads/{platformId}" },
        newHistory: { method: "POST", url: "lead/{leadId}/history" },
        historyIndex: { method: "GET", url: "lead/{leadId}/history" },
        metrics: { method: "GET", url: "lead/metrics/{step}{/firstDate}{/lastDate}{/userId}{?showFunnel}{&actionId}{&plugin*}" },
        metricsAll: { method: "GET", url: "lead/metrics/{actionId}{/firstDate}{/lastDate}" },
        metricsPlatform: { method: "GET", url: "lead/metricsPlatform/{actionId}{/firstDate}{/lastDate}" },
        datatable: { method: "POST", url: "solution/datatable" },
        deletedHistory: { method: "POST", url: "lead/deletedHistory/{idHistory}" },
        resetLead: { method: "POST", url: "lead/automatic/lead-reset" },
        editLead: { method: "PUT", url: "lead/fingerprint" },
        getPluginByAction: { method: "GET", url: "lead/plugin{/firstDate}{/lastDate}{/idPlatform}{/actionId}" },
        leadExportQueue: { method: "POST", url: "integration/queue/lead-export" },
        leadExportAsyncQueue: { method: "POST", url: "integration/async/queue/lead-export" },
        setLeadExport: { method: "POST", url: "integration/bv/set-export" },
    };
    private resource: any = this.$resource("lead{/id}", {}, this.customActions);

    // GET all
    public index() {
        return this.resource.get({}).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    // GET lead show
    public show(id: number) {
        return this.resource.get({ id }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    // POST lead store
    public store(data: any, id_user?: number) {
        if (id_user)
            data.id_user = id_user;

        return this.resource.save({}, data).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    // PUT lead put
    public update(id: number, data: any) {
        return this.resource.update({ id }, data).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    // DELETE  lead delete
    public delete(id: number) {
        return this.resource.delete({ id }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    // get attribute from platform id
    public attribute(platformId: number) {
        return this.resource.attribute({ platformId }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public report(platformName: string, firstDate: any = "", lastDate: any = "") {
        let params = { platformName: platformName };
        if (firstDate != "" && lastDate != "") {
            firstDate = new Date(firstDate);
            firstDate = firstDate.getTime() / 1000;
            lastDate = new Date(lastDate);
            lastDate = lastDate.getTime() / 1000;

            params["firstDate"] = firstDate;
            params["lastDate"] = lastDate;
        }

        return this.resource.report(params).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public chartFilters(firstDate: any = "", lastDate: any = "") {
        let params = {};
        if (firstDate != "" && lastDate != "") {
            firstDate = new Date(firstDate);
            firstDate = firstDate.getTime() / 1000;
            lastDate = new Date(lastDate);
            lastDate = lastDate.getTime() / 1000;

            params["firstDate"] = firstDate;
            params["lastDate"] = lastDate;
        }
        return this.resource.chartFilters(params).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public reportGraphic(
        platformName: string,
        firstDate: any = "",
        lastDate: any = "",
        groupBy: any[],
        filters: any[] = []
    ) {
        let params = { platformName: platformName };
        if (firstDate != "" && lastDate != "") {
            firstDate = new Date(firstDate);
            firstDate = firstDate.getTime() / 1000;
            lastDate = new Date(lastDate);
            lastDate = lastDate.getTime() / 1000;

            params["firstDate"] = firstDate;
            params["lastDate"] = lastDate;
        }

        groupBy = groupBy.map((a) => a.code);

        params["groupBy"] = "";

        if (groupBy.includes("plugin")) params["groupBy"] += '"plugin"';

        if (groupBy.includes("origin"))
            params["groupBy"] +=
                (params["groupBy"].length == 0 ? "" : ",") + '"origin"';

        for (let i = 0; i < groupBy.length; i++) {
            if (!params["groupBy"].includes(groupBy[i]))
                params["groupBy"] +=
                    (params["groupBy"].length == 0 ? "" : ",") + '"' + groupBy[i] + '"';
        }

        filters.map((item) => {
            if (params[item.filter] == undefined) params[item.filter] = [];
            params[item.filter].push(item.name);
        });

        return this.resource.reportGraphic(params).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public updateExport(data: any) {
        return this.resource.updateExport({}, data).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public hotLeadParams(platformId: number) {
        return this.resource.hotLeadParams({ platformId }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public hotLeads(platformId: number) {
        return this.resource.hotLeads({ platformId }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public setHotLeads(platformId: number, data: any) {
        return this.resource.setHotLeads({ platformId }, data).then(
            (response: any) => {
                return [null, response.json()];
            },
            (response: any) => {
                return [response.json(), null];
            }
        );
    }

    public newHistory(leadId: number, data: any) {
        return this.resource.newHistory({ leadId }, data).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public historyIndex(leadId: number) {
        return this.resource.historyIndex({ leadId }).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    public async metrics(actionId?: any , firstDate: string = "", lastDate: string = "", step: string = "", plugin: string = "", showFunnel?: any, userId?: string) {
        let params: {
            step: string,
            showFunnel?: string,
            firstDate?: string,
            lastDate?: string,
            plugin?: string,
            actionId?: string,
            userId?: string,
        } = { step: step };
        
        if (actionId) params.actionId = actionId;
        if (firstDate) params.firstDate = firstDate;
        if (firstDate) params.lastDate = lastDate;
        if (userId) params.userId = userId;
        params.plugin  = plugin ? plugin : '';
        
        if (showFunnel != null || showFunnel != undefined)
            params.showFunnel = showFunnel ? 'true' : 'false';

        return this.resource.metrics(params).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    public datatable(data: any) {
        return this.resource.datatable({}, data);
    }

    public metricsPlatform(platformId?: number | null) {
        return this.resource.metricsPlatform(platformId ? { platformId: platformId } : null).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }
    
    public resetLead(leadsIds: any) {
        let params: any = { leadsIds: leadsIds };
        return this.resource.resetLead({}, params).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    public deletedHistory(idHistory: any) {
        let params: any = { idHistory: idHistory };
        return this.resource.deletedHistory({}, params).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    public editLead(params: any) {
        return this.resource.editLead(params).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    public getPluginByAction(actionId?: number[], firstDate: string = "", lastDate: string = "", idPlatform:string = '') {

        let params: {
            firstDate?: string,
            lastDate?: string,
            idPlatform?: string,
            actionId?: Array<number>
        } = { idPlatform: idPlatform };

        if (Array.isArray(actionId) && actionId.length > 0) {
            params.actionId = actionId;
        }
        if (firstDate) params.firstDate = firstDate;
        if (firstDate) params.lastDate = lastDate;
        return this.resource.getPluginByAction(params).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    public leadExportQueue(params: any) {        
        return this.resource.leadExportQueue(params).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    public leadExportAsyncQueue(params: any) {        
        return this.resource.leadExportAsyncQueue(params).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    public setLeadExport(params: any) {
        return this.resource.setLeadExport(params).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }
}
